import { render, staticRenderFns } from "./slider-picker.vue?vue&type=template&id=836ea146&scoped=true&"
import script from "./slider-picker.vue?vue&type=script&lang=js&"
export * from "./slider-picker.vue?vue&type=script&lang=js&"
import style0 from "./slider-picker.vue?vue&type=style&index=0&id=836ea146&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836ea146",
  null
  
)

export default component.exports